export const taxeList = {
    "0": 0,
    "1": 5.5,
    "2": 10,
    "4": 20
}